<template>
    <div>
        <div class="page-header">
            <div class="md-icon" @click="back">arrow_back</div>
            <div class="title">{{ $t('create') }} {{ $t('terms.organisation') }}</div>
            <el-button type="primary" :loading="saving" @click="save"><i class="md-icon" v-if="!saving">done</i>{{ $t('save') }}</el-button>
        </div>
        <div class="fields-list" v-if="model">
            <dynamic-field v-for="field in fields"
                           :key="field.dbName"
                           v-model="model[field.friendlyName]"
                           :metadata="field" />
        </div>
    </div>
</template>


<script lang="ts">
    import Vue from 'vue';

    import dynamicField from '@/controls/fields/dynamic-field.vue';

    import { EntityType, FieldMetadata, MetadataProvider } from '@/utilities/fields/metadata';
    import { FieldName } from '@/utilities/fields/names';
    import { Organisation, OrganisationProvider } from '@/utilities/api/organisations';
    import { Context } from '@/utilities/contex';

    export default Vue.extend({
        name: 'create-organisation',
        components: {
            dynamicField
        },
        data() {
            return {
                saving: false,
                fields: [] as FieldMetadata[],
                model: null as Organisation | null,
            }
        },
        created() {
            this.initFields();
            this.initModel();
        },
        computed: {
            defaultDomain(): string {
                return this.$route.query.domain?.toString() || '';
            },
            defaultName(): string {
                return this.$route.query.name?.toString() || '';
            },
            returnTo(): string {
                return this.$route.query.returnTo?.toString() || '';
            }
        },
        methods: {
            initFields() {
                const fieldNames = [...new Set([
                    FieldName.OrganisationName,
                    FieldName.OrganisationDivisionName,
                    FieldName.OrganisationType,
                    FieldName.OrganisationStatus,
                    FieldName.OrganisationTelephone,
                    ...MetadataProvider.getEntityFields(EntityType.Organisation).filter(f => f.isMandatory && MetadataProvider.isFieldSupported(f)).map(f => f.dbName)
                ])];
                this.fields = fieldNames
                    .map(f => MetadataProvider.getFieldByName(f)!)
                    .filter(f => f);
            },
            initModel() {
                this.model = {
                    OrganisationId: 0,
                    ...Object.fromEntries(this.fields.map(f => [f.friendlyName, null])),
                    OrganisationOwner: Context.user.userId,
                    OrganisationName: this.defaultName,
                    OrganisationDomain: this.defaultDomain,
                } as any;
            },
            async save() {
                if (!this.model) return;
                if (!MetadataProvider.validateEntity(this.model, this.fields)) return;
                this.saving = true;
                try {
                    const organisationId = await OrganisationProvider.save(this.model);
                    this.$router.push({ path: this.returnTo, query: { organisationId: organisationId.toString() } });
                } catch (e: any) {
                    console.error(e);
                    this.$notify.error({ title: this.$tc('error'), message: e.error || this.$tc('an_unexpected_error_occurred') });
                }
                this.saving = false;
            },
            back() {
                this.$router.back();
            }
        }
    });

</script>

<style scoped lang="scss">

</style>